<div [ngClass]="statusStyles">
	<span>{{statusValue}}</span>
	@if (statusValue === '') {
		<skl-spinner
			[size]="20">
		</skl-spinner>
	}
</div>